module.exports = __webpack_public_path__ + "static/img/about2.947af0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about2.png
// module id = SwEf
// module chunks = 1